import { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../contexts/AdminContext';
import { OptionsType, rolePermission } from '../interfaces/ApplicationInterfaces';
import './EditComponent.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import { ApplicationData, Claims, ExternalEnumRecord, claimEnabledInContext, claimsListToSchema, makeExternalEnumRecord } from '../interfaces/APIInterface';
import MenuItem from '@mui/material/MenuItem';
import { COSMOS_API, POST_ENDPOINT } from '../api/API';
import { ApplicationClaimField } from './ApplicationClaimField';
import { AppEnvSetting, isNullUndefEmpty } from '../ts/common';

interface ClaimsEditingFormProps {
    claimContext: Record<string, string>;
    updateClaims: (data: Record<string, string>) => void;
    claimsSchema: Array<Claims>;
    disabled: boolean;
}

export const ClaimsEditingForm = (props: ClaimsEditingFormProps) => {
    return (
        <Table className="application-table">
            <TableBody>
            {props.claimsSchema.filter(claim => claimEnabledInContext(claim, claimsListToSchema(props.claimsSchema), claim.possibleValues, props.claimContext)).map(claim => {
                return (
                    <TableRow key={`${claim.id}-cedit`}>
                        <TableCell>
                            <ApplicationClaimField
                                claim={claim}
                                claimValue={props.claimContext?.[claim.id] ?? ''}
                                setClaimValue={(appId, cid, cvalue) => {
                                    props.updateClaims({ ...props.claimContext, [cid]: cvalue });
                                }}
                                appId={""}
                                appExternalEnums={{}}
                                disabled={props.disabled || claim.readOnly}
                                claimContext={props.claimContext}
                                claimSchema={claimsListToSchema(props.claimsSchema)}
                            />
                        </TableCell>
                    </TableRow>
                );
            })}
            </TableBody>
        </Table>
    )
}